export default "__VITE_ASSET__3e5799ff__"